import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function Loader({size=20,color='inherit'}) {
  return (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress color={color} size={size} />
    </Box>
  );
}